<template>
    <div>
        <el-row class="case-type-row" v-if="datacollection">
            <el-col :xl="14" :lg="14" :md="24" :sm="24" :xs="24" class="pie-dev">
                <doughnut-chart :chart-data="datacollection" class="dought-pie-chart" :options="options" @showLegend="showCustomLegends"></doughnut-chart>
            </el-col>
            <el-col :xl="10" :lg="10" :md="24" :sm="24" :xs="24" class="list-dev">
                <div id="CaseTypesChart-legend" class="chart-legend" v-html="htmlLegend"></div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import DoughnutChart from "../js/doughnut.js";
    export default {
        components: {
            DoughnutChart
        },
        data() {
            return {
                datacollection: {},
                options: null,
                htmlLegend: null
            }
        },
        mounted() {
            this.fillData()
        },
        methods: {
            fillData() {
                request({
                    url: "get-cases-category-type-count",
                    method: "get",
                    params: this.filterData
                }).then(response => {
                    this.datacollection = response.data.data;
                    this.options = {
                        hover: {
                            mode: null
                        },
                        legend: {
                            display: false,
                        },
                        legendCallback: function (chart) {
                            var legendHtml = [];
                            legendHtml.push('<ul style="list-style: none;" class="' + chart.id + '-legend">');
                            var item = chart.data.datasets[0];
                            for (var i = 0; i < item.data.length; i++) {
                                legendHtml.push('<li>');
                                legendHtml.push('<span style="background-color:' + item.backgroundColor[
                                    i] + '; border-color: ' + item.borderColor[
                                    i] + '; border-width: ' + item.borderWidth + 'px;"></span>');
                                legendHtml.push(chart.data.labels[i]);
                                legendHtml.push('</li>');
                            }
                            legendHtml.push('</ul>');
                            return legendHtml.join("");
                        },
                        responsive: true,
                        maintainAspectRatio: false
                    }
                });
            },
            showCustomLegends(legendsHtml) {
                this.htmlLegend = legendsHtml;
                $("#CaseTypesChart-legend").on('click', "li", function (event) {
                    event = event || window.event;

                    var target = event.target || event.srcElement;
                    while (target.nodeName !== 'LI') {
                        target = target.parentElement;
                    }
                    var parent = target.parentElement;
                    var chartId = parseInt(parent.classList[0].split("-")[0], 10);
                    var chart = Chart.instances[chartId];

                    var index = Array.prototype.slice.call(parent.children).indexOf(target);
                    var meta = chart.getDatasetMeta(0).data[index];
                    if (meta.hidden === false || meta.hidden === null) {
                        meta.hidden = !chart.data.datasets[0].data[index].hidden;
                        target.classList.add('hidden');
                    } else {
                        target.classList.remove('hidden');
                        meta.hidden = null;
                    }
                    chart.update();
                });
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/components/Layout/Widgets/chart/components/CaseTypes.vue